<template>
    <transition
        v-on:enter="enter"
        v-on:leave="leave">
        <div class="el-char"
             v-if="show"
             v-bind:class="classes">
            <span class="el-char__char"
                  v-html="charString"></span>

            <span v-if="index"
                  class="el-char__index">{{index}}</span>
        </div>
    </transition>
</template>

<script>
    import anime from 'animejs';
    import { timeout } from 'donot';

    export default {
        beforeDestroy() {
            this.show = false;
        },

        computed : {
            charString() {
                return this.char === '' ? '✋' : this.char;
            },

            classes() {
                return [`el-char--${this.flair}`];
            }
        },

        data() {
            return { show : false };
        },

        methods : {
            async enter(el, done) {
                if (this.delay) {
                    await timeout(this.delay);
                }

                anime({
                    targets : el,
                    scale : [0, 1],
                    complete() {
                        done();
                    }
                });
            },

            leave(el, done) {
                anime({
                    targets : el,
                    scale : [1, 0],
                    complete() {
                        done();
                    }
                });
            },
        },

        mounted() {
            this.show = true;
        },

        props : {
            char : String,
            delay : Number,
            flair : String,
            index : [Boolean, String]
        }
    }
</script>